import { Box,  Card, Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from "@mui/material";

import LOGO from '../../assets/images/logo.svg';
import { numberFormat } from "../../utils/nunberFormat";

import CancelIcon from '@mui/icons-material/Cancel';
import { useNavigate } from "react-router-dom";

const OrderDetailView = () => {
    const navigate = useNavigate();

    const onClose = () => {
        navigate(-1);
    }

    return <Box>
        <Typography variant="h5" color="#737373" fontWeight="bold" sx={{
            mb: 3
        }}>Order Details</Typography>
        <Card sx={{ boxShadow: '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12);', p: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'end', mb: 2 }}>
                <IconButton onClick={onClose}>
                    <CancelIcon sx={{ color: 'red' }} />
                </IconButton>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <img src={LOGO} alt="" style={{ width: 104, height: 32 }} />
                <Typography fontSize={32}>Order number:J#50</Typography>
                <Typography fontSize={32} fontWeight="bold">Order ID:#dft4325</Typography>
            </Box>
            <Box mt={5}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Typography color="#919EAB" fontWeight="bold">From</Typography>
                        <Box mt={2}>
                            <Typography>Jiffy Phone tong</Typography>
                            <Typography>Vientiane, Dongaxok</Typography>
                            <Typography>Phone: 020 56875796</Typography>
                        </Box>

                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography color="#919EAB" fontWeight="bold">Customer</Typography>
                        <Box mt={2}>
                            <Typography>Vilapanya visounarath</Typography>
                            <Typography>Vientiane, Dongaxok</Typography>
                            <Typography>Phone: 020 56875796</Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <Box mt={5}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Typography color="#919EAB" fontWeight="bold">Order Date</Typography>
                        <Box mt={2}>
                            <Typography>01 Jul 2020</Typography>
                            <Typography>13:00 pm</Typography>

                        </Box>

                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography color="#919EAB" fontWeight="bold">Received Date</Typography>
                        <Box mt={2}>
                            <Typography>01 Jul 2022</Typography>
                            <Typography>14:00 pm</Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <Box mt={10}>
                <TableContainer >
                    <Table>
                        <TableBody>
                            <TableRow hover tabIndex={-1} role="checkbox">
                                <TableCell align="left" sx={{ color: '#637381' }}>#</TableCell>
                                <TableCell align="left" sx={{ color: '#637381' }}>Description</TableCell>
                                <TableCell align="left" sx={{ color: '#637381' }}>Barcode</TableCell>
                                <TableCell align="left" sx={{ color: '#637381' }}>Qty</TableCell>
                                <TableCell align="left" sx={{ color: '#637381' }}>Unit Price</TableCell>
                                <TableCell align="left" sx={{ color: '#637381' }}>Total</TableCell>
                            </TableRow>
                            <TableRow hover tabIndex={-1} role="checkbox">
                                <TableCell align="left" >1</TableCell>
                                <TableCell align="left" >Shampoo 150 ml</TableCell>
                                <TableCell align="left" >111010101</TableCell>
                                <TableCell align="left" >1</TableCell>
                                <TableCell align="left" >{numberFormat(30000)} kip</TableCell>
                                <TableCell align="left" >{numberFormat(30000)} kip</TableCell>
                            </TableRow>
                            <TableRow hover tabIndex={-1} role="checkbox">
                                <TableCell align="left" >2</TableCell>
                                <TableCell align="left" >Shampoo 150 ml</TableCell>
                                <TableCell align="left" >111010101</TableCell>
                                <TableCell align="left" >1</TableCell>
                                <TableCell align="left" >{numberFormat(30000)} kip</TableCell>
                                <TableCell align="left" >{numberFormat(30000)} kip</TableCell>
                            </TableRow>
                            <TableRow hover tabIndex={-1} role="checkbox">
                                <TableCell align="left" >3</TableCell>
                                <TableCell align="left" >Shampoo 150 ml</TableCell>
                                <TableCell align="left" >111010101</TableCell>
                                <TableCell align="left" >1</TableCell>
                                <TableCell align="left" >{numberFormat(30000)} kip</TableCell>
                                <TableCell align="left" >{numberFormat(30000)} kip</TableCell>
                            </TableRow>

                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'end', gap: 5 }}>
                <Box>
                    <Typography textAlign="end">Total Unit</Typography>
                    <Typography textAlign="end">Subtotal</Typography>
                    <Typography textAlign="end">Discount</Typography>
                    <Typography textAlign="end">Taxes</Typography>
                    <Typography textAlign="end">Driver fee</Typography>
                    <Typography textAlign="end" fontWeight="bold">Total</Typography>
                </Box>
                <Box>
                    <Typography textAlign="end">{numberFormat(5)} units</Typography>
                    <Typography textAlign="end">{numberFormat(46500)} kip</Typography>
                    <Typography textAlign="end" color="red">{numberFormat(-2000)} kip</Typography>
                    <Typography textAlign="end">{numberFormat(1000)} kip</Typography>
                    <Typography textAlign="end">{numberFormat(8000)} kip</Typography>
                    <Typography textAlign="end" fontWeight="bold">{numberFormat(53000)} kip</Typography>
                </Box>

            </Box>
        </Card>
    </Box>
}
export default OrderDetailView;